<div class="audio"></div>
<audio #audio [src]="audioSrc"></audio>
<button class="btn speaker" [ngClass]="variant" (click)="handleSpeakerClick(audio)">
  <span inlineSVG="/icons/icon-speaker-current-color.svg"></span>
</button>
